import type { CommunityPost } from '~/interfaces/community';

export const isResourceDiscussionHidden = ({
  attachable_type,
  comments_state,
}: Pick<CommunityPost, 'attachable_type' | 'comments_state'>) =>
  attachable_type === 'CommunityResource' && comments_state === 'hidden';
